<template>
  <v-snackbar
    v-for="(snackbar, index) in snackbars"
    :key="snackbar.key"
    :timeout="calculateTimeout(snackbar)"
    :color="snackbar.type"
    :model-value="true"
    :style="{ bottom: `${index * 90}px` }"
    class="app-snackbar"
    @update:model-value="() => close(snackbar.key!)"
  >
    <div class="d-flex align-center ga-3">
      <v-icon :icon="icons[snackbar.type] ?? icons.info" size="24" />
      <div class="d-flex flex-column min-width-0">
        <span class="text-subtitle-2 font-weight-medium">{{ getTitle(snackbar) }}</span>
        <span v-if="snackbar.text" class="text-body-medium opacity-80">{{ snackbar.text }}</span>
      </div>
    </div>

    <v-progress-linear v-if="snackbar.pending" class="position-absolute bottom-0 left-0" indeterminate />

    <template #actions>
      <v-btn v-if="snackbar.closable" @click="() => close(snackbar.key!)">
        {{ $t("close") }}
      </v-btn>
      <v-btn v-for="(action, actionIndex) in snackbar.actions" :key="actionIndex" :loading="action.loading" @click="action.handler(action)">
        {{ action.label }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
const props = defineProps<{ snackbars: Array<Snackbar> }>()
const { snackbars } = toRefs(props)

const icons: Record<string, string> = {
  success: "check_circle",
  error: "error",
  warning: "warning",
  info: "info",
}

const close = (key: string) => {
  const index = snackbars.value.findIndex((snackbar) => snackbar.key === key)
  snackbars.value.splice(index, 1)
}

/**
 * The timeout only resets if the value is actually changed,
 * so setting 5000 multiple times will not reset the timeout.
 * Add the count so the timeout is reset when the count changes.
 * 5000 is the default vuetify timeout if no timeout is set.
 */
const calculateTimeout = (snackbar: Snackbar) => (snackbar.timeout ?? 5000) + (snackbar.count ?? 0)
const getTitle = (snackbar: Snackbar) => `${snackbar.title}${snackbar.count ? ` (${snackbar.count}x)` : ""}`
</script>

<style>
.app-snackbar {
  /* Disables content-aware padding, otherwise it centers in the container and not the view */
  padding-inline: 0 !important;
}
</style>
